import { MutableRefObject, useEffect, useRef, useState } from "react";
import CardWaitingListUX from "./CardWaitingListUX";
import CardWaitingQueueListUX from "./CardWaitingQueueListUX";
import PatientSearchBoxCU from "../common/PatientSearchBoxCU";
import CONFIG from "config/config";
import SearchBoxDropdown from "react-lib/appcon/common/SearchBoxDropdown";
import { beStringToMoment, formatDatetime } from "react-lib/utils/dateUtils";
import ReactTable, { CellInfo } from "react-table-6";
import moment from "moment";
import { Icon, Pagination, Popup } from "semantic-ui-react";
import { saveAs } from "file-saver";
import { mappingWaitingListStatus, mappingWaitingListStatusColor } from "./CardPatientAppointment";

type CardWaitingListType = {
  onNewWaitingList: any;
  onRefresh: any;
  onShowModWaitingList: any;
  filterWaitingList: any;
  waitingListRowProps: any;
  waitingListSearch: any;
  onChangeWaitingListSearch: any;
  statusOptions: any;
  selectedStatus: any;
  onSelectedStatus: any;
  selectedName: any;
  disabledFilter: any;
  hiddenCreateWaitingList: any;
  disabledFilterDoctor: any;
  filterDoctorOptions: any;
  filterSelectedDoctor: any;
  onChangeFilterSelectedDoctor: any;
  searchPatientNameBox: any;
  onSearchPatientNameBox: any;
  selectedWaitingListName: any;
  setShowModStatic: any;
  setShowModWaitingList: any;
  disableWaitingListManage: any;
  patientListTableWidths: any;
  waitingListItems: any;
  waitingListQueusListItems: any;
  waitingListItemRowProps: any;
  accordionAppointmentOnClick: any;
  openAccordionAppointment: any;
  selectedAppointment: any;
  appointmentList: any;
  appointmentRowProps: any;
  createPatientAppointment: any;
  disabledCreatePatientAppointment: any;
  languageUX: "en" | "th";
  divisionHasWaitingListOptions: any;
  selectedWaitingListDivisionId: any;
  waitingListLoading: any;
  onChangeWaitingListDivision: any;
  proxyController: any;
  onEvent: any;
  django: any;
  waitingListQueueList: any;
  waitingListQueueListItemsForReport: any[];
  waitingListQueueListItemsForPrint: any[];
  waitingListQueueListItemsForPrintType: string
  waitingListQueueListItemsForReportTotals: number;
  waitingListQLStatusOptions: any[];
  waitingListQueueListLoading: boolean;
  waitingListQueueListItemLoading: boolean;
  userPosition: any;
  searchedItemListWithKey: any;
  mapProviderOptions: any;
  masterOptions: any;
  setProp: any;
  providerInfo: any;
  // DEBUG
  waitingList: any;
};

const PAGE_LIMIT = 20;
const CardWaitingList = (props: CardWaitingListType) => {
  const [isModeQueueList, setIsModeQueueList] = useState(false);
  const [selectedPatientId, setSelectedPatientId] = useState(null);
  const [selectedPatientDetail, setSelectedPatientDetail] = useState(null);

  const [hn, setHN] = useState("");
  const hnSearchRefPA = useRef(null) as MutableRefObject<any>;

  const [startDateQL, setStartDateQL] = useState("");
  const [endDateQL, setEndDateQL] = useState("");
  const [completeStartDateQL, setCompleteStartDateQL] = useState("");
  const [completeEndDateQL, setCompleteEndDateQL] = useState("");
  // division
  const [selectedDivision, setselectedDivision] = useState(0);
  const [divisionOptions, setDivisionOptions] = useState<any[]>([]);
  // waiting list
  const [selectedWaitingList, setSelectedWaitingList] = useState<number>(0);
  const [waitingListOptions, setWaitingListOptions] = useState<any[]>([]);
  // status
  const [selectedWaitingStatus, setSelectedWaitingStatus] = useState("ALL");
  const [waitingListStatusOptions, setWaitingListStatusOptions] = useState<any[]>([]);

  // data
  const [queueList, setQueueList] = useState<any[]>([]);
  const [printQueueList, setPrintQueueList] = useState([]);

  // pagination 
  const [filterActivePage, setFilterActivePage] = useState(1);

  const [selectedDoctorQueueList, setSelectedDoctorQueueList] = useState<any>(null);
  const [waitingListQLNoDoctor, setWaitingListQLNoDoctor] = useState(false);
  const [queueNo, setQueueNo] = useState<string>("");


  // Workaround Clear DefaultText
  const [ clearDefaultText, setClearDefaultText] = useState(false)


  const handleSearch = (hnParam: string, activePage: number) => {
    const checked = { ...getWaitingListItemSearchParams(activePage) };
    console.log("checked: ", checked);

    props.onEvent({
      message: "SetScheduling",
      params: {
        action: "GetWaitingListQueueListItem",
        ...getWaitingListItemSearchParams(activePage),
        ...( hnParam && { hn: hnParam })
      },
    });


  }
  const handleOnSelectPatient = (id: any, hn: any, name: string, original: any) => {
    console.log("handleonSelectPatient id: ", id, hn);
    if (id !== null) {
      setHN(hn);
      props.setProp("patientList", []);
      setSelectedPatientId(id);
      setSelectedPatientDetail(original);
      props.onEvent({
        message: "SearchPatient",
        params: { patientSearchText: hn },
      });
      setFilterActivePage(1)
      handleSearch(hn, 1)
    } else {
      setHN("");
    }
  };

  // Division
  useEffect(() => {
    let divisionOpts = props.divisionHasWaitingListOptions;
    if (divisionOpts?.length > 0) {
      divisionOpts.unshift({ text: "ทุกคลินิก", value: 0, key: 0 });
    } else {
      divisionOpts = [];
    }
    setDivisionOptions(divisionOpts);
  }, [props.divisionHasWaitingListOptions]);

  // waitingListQueueList
  useEffect(() => {
    let waitingListOpts = (props.waitingListQueueList || []).map((i: any) => ({
      text: i.name,
      value: i.id,
      key: i.id,
    }));
    waitingListOpts.unshift({ text: "เลือกทั้งหมด", value: 0, key: 0 });
    setWaitingListOptions(waitingListOpts);
    setSelectedWaitingList(0);
    setSelectedWaitingStatus("ALL");
  }, [props.waitingListQueueList]);

  // status
  useEffect(() => {
    let waitingListStatusOpts = props.waitingListQLStatusOptions || [];
    waitingListStatusOpts.unshift({ text: "แสดงทั้งหมด", value: "ALL", key: "L" });
    setSelectedWaitingStatus("ALL");
    setWaitingListStatusOptions(waitingListStatusOpts);
  }, [props.waitingListQLStatusOptions]);

  useEffect(() => {
    if (props.divisionHasWaitingListOptions?.length > 0) {
      props.onEvent({
        message: "SetScheduling",
        params: {
          action: "GetWaitingListQueueList",
          selectedWaitingListId: selectedDivision,
          allDivisionList: props.divisionHasWaitingListOptions
            ?.map((i: any) => i.key)
            ?.filter(Boolean),
          includeCancel: true, // TODO : เอา cancel ด้วยมั้ย
        },
      });
    }
  }, [selectedDivision, props.divisionHasWaitingListOptions]);

  const formatQueueList = (waitingList: any[]) => {
    let report = (waitingList || [])?.map((item: any) => {
      let completeAtDateText = ""
      if (item.completed_at) {
        let yearCompleteAtBE = Number(moment(item.completed_at).format("YYYY")) + 543;
        completeAtDateText = `${moment(item.complete_at).format(`DD/MM/${yearCompleteAtBE}`)}`
      }
      let createdText = ""
      if (item.created) {
        let yearCreatedBE = Number(moment(item.created).format("YYYY")) + 543;
        createdText = `${moment(item.created).format(`DD/MM/${yearCreatedBE} \\[HH:mm\\]`)}`
      }
      let statusText = mappingWaitingListStatus(item.status, !!item.provider_code); // waitingListStatusOptions?.find( (i) => i.value === item.status )?.text;

      const statusColor = mappingWaitingListStatusColor(item.status);

      return {
        ...item,
        waitingListName: waitingListOptions?.find((i) => i.value === item.waiting_list)?.text,
        createdText,
        statusText,
        completeAtDateText,
        statusColor,
      };
    });

    return report
  }
  useEffect(() => {
    let report = formatQueueList(props.waitingListQueueListItemsForReport)
    setQueueList(report);
  }, [props.waitingListQueueListItemsForReport, waitingListStatusOptions]);

  useEffect(() => {

    if (props.userPosition?.student_flag && props.providerInfo) {
      console.log("props.providerInfo", props.providerInfo)
      setSelectedDoctorQueueList({
        "provider_id": props.providerInfo?.provider_id,
        "first_name": props.providerInfo?.first_name,
        "last_name": props.providerInfo?.last_name,
        "code": props.providerInfo?.code,
        "pre_name": props.providerInfo?.pre_name,
      })
    }


  }, [props.userPosition?.student_flag, props.providerInfo])


  useEffect(() => {
    if (props.waitingListQueueListItemsForPrintType === "download") { 
      
      let printList = formatQueueList(props.waitingListQueueListItemsForPrint)
      console.log('printList: ', printList);

      // Need Re Query without pagination
      printList = (printList || []).map((i: any, idx: number) => [
        `${idx + 1}`,
        i.code,
        i.createdText,
        i.patient_hn,
        i.patient_name,
        i.provider_name,
        i.division_name,
        i.waitingListName,
        i.statusText,
        i.reason,
        i.completeAtDateText,
        i.note,
        i.create_by,
      ]);

      console.log("printList: ", printList);
      import("xlsx").then((XLSX) => {
        let workbook = XLSX.utils.book_new();
        workbook.SheetNames.push("waitingList");
        let sheet_data = [
          [
            "ลำดับ",
            "เลขที่คิว",
            "วันที่เข้าคิว",
            "HN",
            "ชื่อสกุล",
            "ทันตแพทย์ / นิสิต",
            "คลินิกที่เข้าคิว",
            "ชื่อกลุ่มงาน",
            "สถานะคิว",
            "เหตุผลในการยกเลิก / พักคิว",
            "วันที่ Complete Case",
            "รายละเอียดงาน",
            "ผู้นำเข้าคิว",
          ],
        ];
        // console.log('sheet_data: ', sheet_data);
        sheet_data = sheet_data.concat(printList);
        // console.log('sheet_data: ', sheet_data);
        const sheet = XLSX.utils.aoa_to_sheet(sheet_data);
        workbook.Sheets["waitingList"] = sheet;
        const output = XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
        saveAs(
          new Blob([s2ab(output)], { type: "application/octet-stream" }),
          "รายงานสรุปรายชื่อ waiting list.xlsx"
        );
      });

    } else if ( props.waitingListQueueListItemsForPrintType === "print") {
       let printList = formatQueueList(props.waitingListQueueListItemsForPrint)
       console.log('printList: ', printList);

          const wlSearchParams = getWaitingListItemSearchParams();

            props.onEvent({
              message: "PrintScheduling",
              params: {
                form: "FormWaitingListQueueList",
                data: {
                  // status_name: isOnHoldQ ? "STALL" : isAppointed ? "PENDING" : "ALL",
                  waiting_list_name: waitingListOptions?.find(
                    (i: any) => i.value === selectedWaitingList
                  )?.text,
                  division_name: divisionOptions?.find((i: any) => i.key === selectedDivision)
                    ?.text,
                  status_code: waitingListStatusOptions?.find(
                    (i: any) => i.value === selectedWaitingStatus
                  )?.text,
                  // provider_name: `${selectedDoctorAddWaiting?.first_name} ${selectedDoctorAddWaiting?.last_name}`,
                  // orders: manageWaitingListItems,
                  startDate: wlSearchParams.startDate,
                  endDate: wlSearchParams.endDate,
                  userPrint: props.django.user.full_name,
                  datePrint: formatDatetime(new Date(), true),
                  // status_code: (waitingListStatusOptions || [])
                  //   ?.map((statusName: any) => {
                  //     let value = props.masterOptions?.waitingListStatus?.find(
                  //       (m: any) => m.value === statusName
                  //     )?.value;
                  //     return mappingWaitingListStatusOptions(value) || "";
                  //   })
                  //   .join(", "),
                  // completeStart: wlSearchParams.completeStart,
                  // completeEnd: wlSearchParams.completeEnd,
                  // replace orders ( need full data )
                  orders: printList,
                  waitingListOptions: waitingListOptions,
                },
                // currentQueryParams: wlSearchParams,
              },
            });
    }

    props.setProp("waitingListQueueListItemsForPrintType", "")
  }, [props.waitingListQueueListItemsForPrintType])
  
  
  const getWaitingListItemSearchParams = (activePage?: number) => {
    let query = {
      ...(activePage && {  
        offset: (activePage - 1) * PAGE_LIMIT ,
        pageLimit: PAGE_LIMIT 
      }), 
     
      ...(selectedDivision !== 0 && {divisionId: selectedDivision}  ),
      includeCancel: true,
      ...(!waitingListQLNoDoctor && { doctor: selectedDoctorQueueList }),
      onlyProviderNull: !!waitingListQLNoDoctor,
      ...(selectedWaitingList !== 0 && { waiting_list_id: selectedWaitingList }), // ทุกงาน คือ 0
      startDate: startDateQL ? beStringToMoment(startDateQL)?.toISOString() : null,
      endDate: endDateQL ? beStringToMoment(endDateQL).endOf("days")?.toISOString() : null,
      ...(hn && { hn: hn }),
      ...(queueNo && { queueNo: queueNo }),
      ...(completeStartDateQL && {
        completeStart: beStringToMoment(completeStartDateQL)?.toISOString(),
      }),
      ...(completeEndDateQL && {
        completeEnd: beStringToMoment(completeEndDateQL).endOf("days")?.toISOString(),
      }),
      ...(selectedWaitingStatus !== "ALL" && {
        statusList: [
          props.masterOptions?.waitingListStatus?.find(
            (m: any) => m.value === selectedWaitingStatus
          )?.key,
        ],
      }), // ทุกสถานะคือ ALL
    };
    console.log('getWaitingListItemSearchParams query: ', query);
    return query
  };

  const columns = [
    {
      Header: "เลขที่คิว",
      accessor: "code",
      width: 50,
      style: { textAlign: "center" },
    },
    {
      Header: "วันที่เข้าคิว",
      accessor: "createdText",
      width: 80,
    },
    {
      Header: "HN",
      accessor: "patient_hn",
      width: 72,
      style: { textAlign: "center" },
    },
    {
      Header: "ชื่อ - สกุล",
      accessor: "patient_name",
    },
    {
      Header: "เบอร์โทร",
      accessor: "patient_tel",
      width: 90,
    },
    {
      Header: "ทันตแพทย์ / นิสิต",
      accessor: "provider_name",
    },
    {
      Header: "คลินิกที่เข้าคิว",
      accessor: "division_name",
    },
    {
      Header: "ชื่อกลุ่มงาน",
      accessor: "waitingListName",
    },
    {
      Header: "สถานะคิว",
      style: { textAlign: "center" },
      width: 105,
      Cell: (props: CellInfo) => {


        if (props.original.status === "CANCEL") {
          return (
            <Popup
              content={props.original.reason ? props.original.reason : "-"}
              position="top center"
              trigger={
                <div style={{ color: "red" }}>
                  {props.original.statusText} <Icon name="info circle" />{" "}
                </div>
              }
            />
          );
        } else if (props.original.status === "STALL") {
          return (
            <Popup
              content={props.original.reason ? props.original.reason : "-"}
              position="top center"
              trigger={
                <div style={{ color: "orange" }}>
                  {props.original.statusText} <Icon name="info circle" />{" "}
                </div>
              }
            />
          );
        } else if (props.original.status === "COMPLETED") {
          return (
            <div style={{ color: "green" }}>
              {`${props.original.statusText} (${props.original.completeAtDateText})`}{" "}
            </div>
          );
        } else {
          return <div>{props.original.statusText}</div>;
        }
      },
    },
    {
      Header: "รายละเอียดงาน",
      accessor: "note",
      style: { textAlign: "center" },
    },
    {
      Header: "ผู้นำเข้าคิว",
      accessor: "create_by",
      width: 80,
    },
  ];

  console.log("CardWaitingList props.waitingListQueueList: ", props.waitingListQueueList);
  console.log(
    "CardWaitingList props.waitingListQueueListItemsForReport: ",
    props.waitingListQueueListItemsForReport
  );

  // Download File
  const s2ab = (s: any) => {
    let buf = new ArrayBuffer(s.length); //convert s to arrayBuffer
    let view = new Uint8Array(buf); //create uint8array as viewer
    for (var i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff; //convert to octet
    return buf;
  };

  console.log(" CardWaitingList props: ", props)
  console.log(" CardWaitingList queueList: ", queueList)

  return (
    <>
      {isModeQueueList ? (
        <CardWaitingQueueListUX
          exitQueueList={() => setIsModeQueueList(!isModeQueueList)}
          patientSearchCU={
            <PatientSearchBoxCU
              ref={hnSearchRefPA}
              modalStyle={{ width: "auto" }}
              controller={props.proxyController}
              inputChangeAutoSearch={false}
              onSelectPatient={handleOnSelectPatient}
              onEnter={handleOnSelectPatient}
              systemHn8Digit={CONFIG.COMPANY === "CU"}
              fluid={true}
              userProfile={props?.django?.user}
              languageUX={props.languageUX}
            />
          }
          onChangeWaitingListDivision={(e, data) => {
            // props.onChangeWaitingListDivision()
            setselectedDivision(data.value);
          }}
          divisionHasWaitingListOptions={divisionOptions}
          selectedWaitingListDivisionId={selectedDivision}
          // selectedDoctorQueueList e.g.
          //{
          // "provider_id": 1557,
          // "first_name": "ศิริกาญจน์",
          // "last_name": "ทองมีอาคม",
          // "code": "5136106432",
          // "pre_name": "นทพ."
          // }
          doctorSelector={
            <SearchBoxDropdown
              type="Provider"
              id="8"
              style={{ width: "100%" }}
              fluid={true}
              label=""
              clearable={true}
              placeholder="ค้นหาแบบไม่ระบุแพทย์"
              disabled={
                (props.userPosition?.student_flag === true &&
                  props.django?.user?.role_types?.includes("DOCTOR")) ||
                waitingListQLNoDoctor
              }
              onClear={() => {
                setClearDefaultText(true);
              }}
              {...(props.providerInfo?.doctor_info?.name_code &&
                props.django?.user?.role_types?.includes("DOCTOR") &&
                !clearDefaultText && {
                  defaultText: props.providerInfo?.doctor_info?.name_code,
                })}
              // defaultText={`${props.providerInfo?.doctor_info?.name_code}`}
              toDisplay={(item: any) =>
                `${item.pre_name || ""} ${item.first_name} ${item.last_name} [${item.code}]`
              }
              onEvent={props.onEvent}
              // searchedItemList={props.searchedItemList}
              searchedItemListWithKey={props.searchedItemListWithKey}
              selectedItem={selectedDoctorQueueList}
              setSelectedItem={(value: any, key: any) => {
                if (value === null && key === null) {
                  setSelectedDoctorQueueList(null);
                  return;
                }
                let doctor = props.searchedItemListWithKey?.Provider_8?.find(
                  (item: any) => item.provider_id === key
                );
                console.log("setSelectedDoctor doctor: ", doctor);
                setSelectedDoctorQueueList(doctor);
              }}
              useWithKey={true}
              mapOptions={props.mapProviderOptions}
            />
          }
          waitingListQLNoDoctor={waitingListQLNoDoctor}
          onChangeWaitingListQLNoDoctor={(e, { checked }) => {
            if (checked) {
              setSelectedDoctorQueueList(null);
            }
            setWaitingListQLNoDoctor(checked);
          }}
          startDateQL={startDateQL}
          endDateQL={endDateQL}
          completeStartDateQL={completeStartDateQL}
          completeEndDateQL={completeEndDateQL}
          onChangeStartDateQL={(date: string) => setStartDateQL(date)}
          onChangeEndDateQL={(date: string) => setEndDateQL(date)}
          onChangeCompleteStartDateQL={(date: string) => setCompleteStartDateQL(date)}
          onChangeCompleteEndDateQL={(date: string) => setCompleteEndDateQL(date)}
          disabledWaitingListDivision={false}
          disabledSelectedWaitingList={waitingListOptions?.length <= 1}
          disabledSelectedStatus={
            waitingListStatusOptions?.length <= 1 || waitingListOptions?.length <= 1
          }
          waitingListOptions={waitingListOptions}
          selectedWaitingList={selectedWaitingList}
          onChangeSelectedWaitingList={(e, data) => {
            setSelectedWaitingList(data.value as number);
          }}
          waitingListStatusOptions={waitingListStatusOptions}
          onChangeSelectedStatus={(e, data) => setSelectedWaitingStatus(data.value)}
          selectedWaitingStatus={selectedWaitingStatus}
          disabledSearch={false}
          disabledPrint={false}
          disabledDownload={false}
          queueNo={queueNo}
          onChangeQueueNo={(e, data) => setQueueNo(data.value as string)}
          onClickDownload={async () => {

            await props.onEvent({
              message: "SetScheduling",
              params: {
                action: "GetWaitingListQueueListItemForPrint",
                ...getWaitingListItemSearchParams(),
                type: "download"
              },
            });
            
          }}
          onClickPrint={ async () => {

             await props.onEvent({
              message: "SetScheduling",
              params: {
                action: "GetWaitingListQueueListItemForPrint",
                ...getWaitingListItemSearchParams(),
                type: "print"
              },
            });

            
          }}
          onClickSearch={() => { 
            setFilterActivePage(1);
            handleSearch("", 1);
          }}
          tableQueueList={
            <ReactTable
              loading={props.waitingListQueueListItemLoading}
              data={queueList}
              columns={columns}
              showPagination={false}
              style={{ height: "55vh", fontSize: "smaller" }}
            />
          }
          pagination={ props.waitingListQueueListItemsForReportTotals > 0 ? <Pagination
              boundaryRange={0}
              activePage={filterActivePage}
              onPageChange={(e, { activePage }) => {
                setFilterActivePage(activePage as number);
                handleSearch("", activePage as number)
              }}
              defaultActivePage={1}
              siblingRange={1}
              totalPages={Math.ceil(props.waitingListQueueListItemsForReportTotals / PAGE_LIMIT)} 
            /> : null 
          }
        />
      ) : (
        <CardWaitingListUX
          // Feature 76350
          onClickSummaryQueueList={() => {
            setIsModeQueueList(!isModeQueueList);
          }}
          onNewWaitingList={props.onNewWaitingList}
          onRefresh={props.onRefresh}
          onShowModWaitingList={props.onShowModWaitingList}
          filterWaitingList={props.filterWaitingList}
          waitingListRowProps={props.waitingListRowProps}
          waitingListSearch={props.waitingListSearch}
          onChangeWaitingListSearch={props.onChangeWaitingListSearch}
          statusOptions={props.statusOptions}
          selectedStatus={props.selectedStatus}
          onSelectedStatus={props.onSelectedStatus}
          selectedName={props.selectedName}
          disabledFilter={props.disabledFilter}
          hiddenCreateWaitingList={props.hiddenCreateWaitingList}
          disabledFilterDoctor={props.disabledFilterDoctor}
          filterDoctorOptions={props.filterDoctorOptions}
          filterSelectedDoctor={props.filterSelectedDoctor}
          onChangeFilterSelectedDoctor={props.onChangeFilterSelectedDoctor}
          searchPatientNameBox={props.searchPatientNameBox}
          onSearchPatientNameBox={props.onSearchPatientNameBox}
          selectedWaitingListName={props.selectedWaitingListName}
          setShowModStatic={props.setShowModStatic}
          setShowModWaitingList={props.setShowModWaitingList}
          disableWaitingListManage={props.disableWaitingListManage}
          patientListTableWidths={props.patientListTableWidths}
          waitingListItems={props.waitingListItems}
          waitingListItemRowProps={props.waitingListItemRowProps}
          accordionAppointmentOnClick={props.accordionAppointmentOnClick}
          openAccordionAppointment={props.openAccordionAppointment}
          selectedAppointment={props.selectedAppointment}
          appointmentList={props.appointmentList}
          appointmentRowProps={props.appointmentRowProps}
          createPatientAppointment={props.createPatientAppointment}
          disabledCreatePatientAppointment={props.disabledCreatePatientAppointment}
          languageUX={props.languageUX}
          divisionHasWaitingListOptions={props.divisionHasWaitingListOptions}
          selectedWaitingListDivisionId={props.selectedWaitingListDivisionId}
          waitingListLoading={props.waitingListLoading}
          onChangeWaitingListDivision={props.onChangeWaitingListDivision}
        />
      )}
    </>
  );
};

export default CardWaitingList;
